import DataConnector from 'connect/DataConnector';
import {restArrayToGraphQL} from 'graphql-client/declarative-translations/external/translate';
import {ManagedModelType} from 'models/ManagedModelDefinitions';

import {AuthorGraphQL} from '../../graphql-fragments/parties/__generated/AuthorGraphQL';
import Authors from './Authors';

interface Props {
  itemId: string;
}

interface EnhancedProps {
  authors: Array<AuthorGraphQL> | null;
}

class AuthorsConnector extends DataConnector<Props, EnhancedProps> {
  enhanceProps(): EnhancedProps {
    const authors = this.getOrFetchOptional(ManagedModelType.AUTHORS_BY_ITEM_ID, this.props.itemId);
    return {
      authors: authors != null ? restArrayToGraphQL('Author', authors) : null,
    };
  }
}

export default AuthorsConnector.connect(Authors);
